var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-ticket-mode--view" }, [
    _c("div", { staticClass: "event-ticket--title" }, [
      _c("h5", { staticClass: "card-title h5-responsive mb-0" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.langData(_vm.ticket, "title")) +
              " " +
              _vm._s(_vm.ticket.id)
          )
        ])
      ]),
      _vm._v(" "),
      _c("section", { attrs: { "data-open-close-time": "" } }, [
        _c("i", { staticClass: "fa fa-clock" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.methods_available.readEventTicketAttribute(
                _vm.ticket,
                "open_close_full",
                ["open_time", "value"],
                [
                  "ticket_data",
                  "entity_type_data",
                  "entity_type_fields",
                  "groups",
                  "open_close_full",
                  "items",
                  "open_time",
                  "value"
                ]
              )
            ) + "\n                "
          )
        ]),
        _vm._v("\n            -\n            "),
        _c("span", [
          _vm._v(
            "\n                    " +
              _vm._s(
                _vm.methods_available.readEventTicketAttribute(
                  _vm.ticket,
                  "open_close_full",
                  ["close_time", "value"],
                  [
                    "ticket_data",
                    "entity_type_data",
                    "entity_type_fields",
                    "groups",
                    "open_close_full",
                    "items",
                    "close_time",
                    "value"
                  ]
                )
              ) +
              "\n                "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-content-center" },
      [
        _c("div", { staticClass: "event-ticket--price" }, [
          _c("p", { staticClass: "mb-1" }, [_vm._v("Current Price")]),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.formatPrice(_vm.ticket.price)))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "event-ticket--sales" }, [
          _c("p", { staticClass: "mb-1" }, [_vm._v("SALES")]),
          _vm._v(" "),
          _c("h4", {
            domProps: {
              innerHTML: _vm._s(_vm.methods_available.readEarnings(_vm.ticket))
            }
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "text-center d-flex justify-content-md-between pt-2 pb-2"
      },
      [
        _vm.layout.current === "list" ? _c("div") : _vm._e(),
        _vm._v(" "),
        _c(
          "BaseBadge",
          {
            staticClass: "event-ticket-allocated",
            attrs: { title: "Used", cls: "badge-secondary" }
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.readUsed(_vm.ticket)) + "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "BaseBadge",
          {
            staticClass: "event-ticket-allocated",
            attrs: { title: "Allocated" }
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.ticket.allocated) + "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "BaseBadge",
          {
            staticClass: "event-ticket-remaining",
            attrs: { title: "Remaining" }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.readAvailable(_vm.ticket)) +
                "\n        "
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34bbe0ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bbe0ba","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/pages/ticketing/EventTicketModeView.vue
// module id = 381
// module chunks = 0